import { useEffect, useState } from "react";
import { ArrowUpRight, PenLine } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { BLOG_URL } from "@/data/content";

const decode = (t) => new DOMParser().parseFromString(t, "text/html").documentElement.textContent;

const BlogSection = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetch("https://public-api.wordpress.com/wp/v2/sites/hrmexpress.wordpress.com/posts?per_page=3&_fields=link,title")
      .then((r) => r.json())
      .then((data) => setPosts(Array.isArray(data) ? data : []))
      .catch(() => setPosts([]));
  }, []);

  return (
    <section id="blog" data-testid="blog-section" className="relative py-20 sm:py-28 bg-kiki-surface/60">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal><Eyebrow>Insights & resources</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display text-4xl sm:text-6xl font-medium tracking-tight text-kiki-ink mt-3 leading-[1.05]">
            From our blog
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-3 text-base text-kiki-muted">Insights and resources for HR professionals.</p>
        </Reveal>

        <Reveal delay={0.2}>
          <a
            data-testid="blog-card"
            href={BLOG_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 flex items-center gap-5 rounded-2xl border border-kiki-line bg-white p-6 hover:border-kiki-gold/40 transition-colors duration-300 group"
          >
            <span className="w-14 h-14 rounded-full bg-kiki-surface flex items-center justify-center text-kiki-gold shrink-0">
              <PenLine className="w-5 h-5" />
            </span>
            <div className="flex-1">
              <h3 className="font-display text-2xl font-medium text-kiki-ink">HRM Express</h3>
              <p className="text-sm text-kiki-muted font-light">hrmexpress.wordpress.com</p>
            </div>
            <ArrowUpRight className="w-5 h-5 text-kiki-ink group-hover:text-kiki-gold group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300" />
          </a>
        </Reveal>

        {posts.length > 0 && (
          <div data-testid="blog-latest" className="mt-6 divide-y divide-kiki-line border-y border-kiki-line">
            {posts.map((post, i) => (
              <a
                key={post.link}
                data-testid={`blog-post-${i}`}
                href={post.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-between gap-4 py-4 group"
              >
                <span className="text-sm sm:text-base text-kiki-ink font-light group-hover:text-kiki-gold transition-colors duration-300">
                  {decode(post.title.rendered)}
                </span>
                <ArrowUpRight className="w-4 h-4 shrink-0 text-kiki-muted group-hover:text-kiki-gold transition-colors duration-300" />
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default BlogSection;
